import React from "react";
import { Link, useLocation } from "react-router-dom";
import { breadcrumbs } from "../../core/data/interface/interface";
import { all_routes } from "../router/all_routes";

const Breadcrumbs = (props: breadcrumbs) => {
  const routes = all_routes;
  const location = useLocation();
  let addButton = null;
  if (
    location.pathname.startsWith(routes.listinggrid) ||
    location.pathname.startsWith(routes.listinglist) ||
    location.pathname.startsWith(routes.bookingcheckout) ||
    location.pathname.startsWith(routes.booking) ||
    location.pathname.startsWith(routes.invoice) ||
    location.pathname.startsWith(routes.listingdetails) ||
    location.pathname.startsWith(routes.ourteam) ||
    location.pathname.startsWith(routes.testimonial) ||
    location.pathname.startsWith(routes.termsconditions) ||
    location.pathname.startsWith(routes.privacypolicy) ||
    location.pathname.startsWith(routes.aboutus) ||
    location.pathname.startsWith(routes.pricing) ||
    location.pathname.startsWith(routes.faq) ||
    location.pathname.startsWith(routes.gallery) ||
    location.pathname.startsWith(routes.bloglist) ||
    location.pathname.startsWith(routes.bloggrid) ||
    location.pathname.startsWith(routes.contact)
  ) {
    addButton = (
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title">{props.title}</h2>
              <nav aria-label="breadcrumb" className="page-breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.home}>Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">{props.subtitle}</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {props.title}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    addButton = (
      <div className="row align-items-center">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/admin-dashboard">{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul>
        </div>
        <div className="col-auto float-end ms-auto"></div>
      </div>
    );
  }
  return (
    <>
      <div className="page-header">{addButton}</div>
    </>
  );
};

export default Breadcrumbs;
